export * from './ScanFramePeopleIcon';
export * from './ScanFramePeopleIcon16Light';
export * from './ScanFramePeopleIcon16Regular';
export * from './ScanFramePeopleIcon16Solid';
export * from './ScanFramePeopleIcon20Light';
export * from './ScanFramePeopleIcon20Regular';
export * from './ScanFramePeopleIcon20Solid';
export * from './ScanFramePeopleIcon24Regular';
export * from './ScanFramePeopleIcon24Solid';
export * from './ScanFramePeopleIcon32Regular';
export * from './ScanFramePeopleIcon64Regular';
